<template>
	<div>
		<h1>Admin: Manage Invitations</h1>
		<form @submit.prevent="generateToken">
			<div class="mb-3">
				<label for="email" class="form-label">Email Address</label>
				<input
					type="email"
					class="form-control"
					id="email"
					v-model="email"
					required />
			</div>
			<button type="submit" class="btn btn-primary">Generate Token</button>
		</form>
		<h2>Existing Tokens</h2>
		<ul>
			<li v-for="token in tokens" :key="token.code">
				{{ token.email }} - {{ token.code }} -
				{{ token.used ? "Used" : "Unused" }}
				<button @click="revokeToken(token.code)" v-if="!token.used">
					Revoke
				</button>
			</li>
		</ul>
	</div>
</template>

<script setup>
	import { ref, onMounted } from "vue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { useTokenStore } from "@/stores/token"

	// const tokenStore = useTokenStore()
	// tokenStore.loadTokens()

	const email = ref("")
	const tokens = ref([])

	const fetchTokens = async () => {
		try {
			const response = await fetchWithAuth("/api/admin/invites", {
				// headers: {
				// 	Authorization: `Bearer ${tokenStore.token}`,
				// },
			})
			if (!response.ok) throw new Error("Network response was not ok")
			tokens.value = await response.json()
		} catch (err) {
			console.error(err)
		}
	}

	const generateToken = async () => {
		try {
			const response = await fetchWithAuth("/api/admin/invites", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `Bearer ${tokenStore.token}`,
				},
				body: JSON.stringify({ email: email.value }),
			})
			if (!response.ok) throw new Error("Network response was not ok")
			email.value = "" // Clear the email input field
			fetchTokens()
		} catch (err) {
			console.error(err)
		}
	}

	const revokeToken = async (code) => {
		try {
			const response = await fetchWithAuth("/api/admin/invites", {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `Bearer ${tokenStore.token}`,
				},
				body: JSON.stringify({ code }),
			})
			if (!response.ok) throw new Error("Network response was not ok")
			fetchTokens()
		} catch (err) {
			console.error(err)
		}
	}

	onMounted(fetchTokens)
</script>
